import { motion } from "motion/react"
import { Notification } from "../../types/entities/notification"

const BODY = "'Manrope', sans-serif"
const MONO = "'JetBrains Mono', monospace"

type NotificationItemProps = {
    item: Notification
    onRead: (id: string) => void
    index?: number
}

export default function NotificationItem({ item, onRead, index = 0 }: NotificationItemProps) {
    const date = new Date(item.timestamp * 1000).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
    })

    return (
        <motion.button
            type="button"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.06 }}
            onClick={() => !item.read && onRead(item.id)}
            className="w-full text-left rounded-[18px] border overflow-hidden relative transition-all"
            style={{
                background: item.read ? "rgba(255,255,255,0.04)" : "rgba(52,155,230,0.1)",
                borderColor: item.read ? "rgba(255,255,255,0.08)" : "rgba(52,155,230,0.2)",
                borderLeftWidth: item.read ? undefined : "3px",
                borderLeftColor: item.read ? undefined : "#e4206b",
            }}>
            <div className="p-5">
                {!item.read && (
                    <div
                        className="absolute top-4 right-4 size-2.5 rounded-full"
                        style={{ background: "#349be6", boxShadow: "0 0 8px rgba(52,155,230,0.7)" }}
                    />
                )}
                <p
                    className="text-[15px] mb-2 pr-6"
                    style={{
                        fontFamily: BODY,
                        fontWeight: item.read ? 500 : 700,
                        color: item.read ? "rgba(255,255,255,0.6)" : "white",
                    }}>
                    {item.body}
                </p>
                <p className="text-[11px] text-white/25" style={{ fontFamily: MONO }}>
                    {item.day || date}
                </p>
            </div>
        </motion.button>
    )
}
